<script>
  import { mapGetters, mapActions } from "vuex";
  import * as Helper from "@/modules/helper/index";
  import ImageBrowser from "./ImageBrowser.vue";

  export default {
    components: {
      appImageBrowser: ImageBrowser
    },
    computed: {
      ...mapGetters(["ImageGalleries", "MainMenuLayout", "AppConfig"]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id;
      },
      AlbumId() {
        return this.$f7route.params.AlbumId;
      },
      AlbumDetails() {
        let album
        for (let i = 0; i < this.ImageGalleries.Galleries.length; i++) {
          album = this.ImageGalleries.Galleries[i].Albums.find(
            a => a.Id === this.$f7route.params.AlbumId
          );
          if (Helper.IsValid(album)) {
            break;
          }
        }
        return album;
      }
    },
    created() {
      this.$showLoader();
       if (!Helper.IsDevSim()) {
        this.loadModulesImageGalleriesLocalData(this.SubscriptionModuleId)
        this.loadImageGalleries(this.SubscriptionModuleId)
          .then(() => {
            this.$hideLoader();
            this.$RegisterPageView({
              SubscriptionModule_Id: this.SubscriptionModuleId,
              ContentGUID: this.AlbumId,
              ViewType: 2
            });
          })
          .catch(err => {
            console.log("image err", err);
            this.$hideLoader();
          });
      } else {
        this.$hideLoader();
        // this.$RegisterPageView({
        //   SubscriptionModule_Id: this.SubscriptionModuleId,
        //   ContentGUID: this.AlbumId,
        //   ViewType: 2
        // });
      }
    },
    beforeDestroy() {
      if (Helper.IsValid(this.PostDetails)) {
        let selcat = this.AlbumDetails.Category;
        this.setActiveAlbumCategory(selcat);
      }
    },
    methods: {
      ...mapActions([
        "loadModulesImageGalleriesLocalData",
        "setActiveAlbumCategory",
        "loadImageGalleries"
      ]),
      getStyle: function(ismaterial) {
        if (ismaterial && !this.ImageGalleries.Parent.UseCategories) {
          return {
            marginTop: "50px",
            padding: "0px 5px"
          };
        } else if (!ismaterial && !this.ImageGalleries.Parent.UseCategories) {
          return {
            marginTop: "50px",
            padding: "0px 5px"
          };
        } else {
          return {
            marginTop: "10px",
            padding: "0px 5px"
          };
        }
      }
    }
  };
</script>
<template>
  <f7-page :page-content="false" name="image-album-view">
    <app-header v-if="AlbumDetails" :header="AlbumDetails.AlbumName" :isShowRightNavBar="false"></app-header>
    <div class="backgroundimg"></div>
    <app-image-browser v-if="AlbumDetails" :Parent="ImageGalleries.Parent" :SubscriptionModuleId="SubscriptionModuleId" :images="AlbumDetails.Images?AlbumDetails.Images:[]" :albumId="AlbumId" :albumName="AlbumDetails.AlbumName"></app-image-browser>
  </f7-page>
</template>


// WEBPACK FOOTER //
// src/components/image-gallery/ImageGalleryDetail.vue